// import React, { useEffect } from "react";
import {BehaviorSubject, Observable} from 'rxjs';
import {
    IComponentContext,
    UpdateCommand,
    ComponentContextReadyState,
    DataflowIntegration,
    ComponentContextCreateOptions,
    SingleValueParameter,
} from "@sa/rep-core";

export class ContextExample implements IComponentContext {
  public id: string;
  public readonly dataflowIntegration: DataflowIntegration;
  public readyState: ComponentContextReadyState;
  protected _value: BehaviorSubject<string>;
  public get value(): Observable<string> {
    return this._value.asObservable();
  }

  constructor(id: string, createOptions: ComponentContextCreateOptions) {
      this.id = id;

      this.dataflowIntegration = {
          canIntegrate: true, // Указываем, что компонент интегрируется к Dataflow сервису (и может управляться с помощью параметров отчёта)
          integrated: false,
      };

      this.readyState = ComponentContextReadyState.Loaded;

      const parameter = createOptions.dataflowService.getParameter("Parameter1") as SingleValueParameter;
      this._value = new BehaviorSubject(parameter.value as string);
  }

  update(command: UpdateCommand): Promise<void> {
      const value = command.values.get("Parameter1");
      if (value !== undefined) {
          this._value.next(value as string);
      }
      return Promise.resolve();
  }
}